import { createRoute, useEntityUrl } from 'framework/routing';
import { TASK_CONSTRUCTOR_PATH } from './constants';

export const useTaskConstructorRoute = () => createRoute({ listRoute: TASK_CONSTRUCTOR_PATH });

export const useTaskConstructorUrl = () => useEntityUrl({ baseLink: TASK_CONSTRUCTOR_PATH });
